export interface ProfileSectionNameProps {
  headline?: string;
  name?: string;
}

export const ProfileSectionName = ({
  headline = "",
  name = "",
}: ProfileSectionNameProps) => (
  <div className="flex max-w-[128px] flex-col text-left">
    <span className="text-c-sidebar truncate text-sm font-medium">{name}</span>
    <span className="text-c-sidebar truncate text-sm font-normal">
      {headline}
    </span>
  </div>
);
